import React from 'react';
import { Anchorme } from 'react-anchorme';
import { humanized_time_span } from '../../../../../utils/humanized_time_span';
import { wrapEventHandler } from '../../../../../utils/handlers';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';

class AdminReplyItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleReplySaveClick = e => {
    const text = this.refs.replyText.value;
    this.props.handleReplySave(text);
  };

  render() {
    let contentBlock;
    const replyClass = 'reply-editor xlate-none';
    if (this.props.showReplyEditing) {
      let existingReply;
      if (this.props.reply) {
        existingReply = this.props.reply.comment;
      }
      contentBlock = [
        <textarea ref="replyText" defaultValue={existingReply || ''} />,
        <div className="btn-container-right">
          <button className="btn blue-save" onClick={wrapEventHandler(this.handleReplySaveClick)}>
            {StringConstantsMixin.strings.SAVE}
          </button>
          <button className="btn blue-save" onClick={this.props.handleReplyEditCancel}>
            {StringConstantsMixin.strings.CANCEL}
          </button>
        </div>
      ];
    }
    if (this.props.reply) {
      let displayName = 'AllTrails';
      let deleteBlock;
      // only show author's name if another admin is viewing
      if (this.props.adminUser) {
        displayName = this.props.reply.user.firstName;
        deleteBlock = <a href="" onClick={wrapEventHandler(this.props.handleDeleteReplyClick)} className="delete-track pull-right" rel="nofollow" />;
      }
      const timeText = humanized_time_span(this.props.reply.metadata.created, this.props.locale);
      contentBlock = [
        <div className="green-block pull-left" />,
        <div className="comment-reply-content">
          <h3>{StringConstantsMixin.strings.CONTRIBUTE.COMMENT_FROM.replace(/{userFirstName}/g, displayName)}</h3>
          <h4>{` - ${timeText}`}</h4>
          <p>
            <Anchorme target="_blank" rel="noreferrer noopener">
              {this.props.reply.comment}
            </Anchorme>
          </p>
        </div>,
        deleteBlock
      ];
    }

    return <div className={replyClass}>{contentBlock}</div>;
  }
}

export default AdminReplyItem;
